import React, { useEffect, useRef, useState } from "react";
import getText from "Translator";
import {
  getNotifications,
  updateNotificationReaded,
} from "controllers/NotificationController";
import { getFileWithID } from "controllers/FileController";

import { List, ListItem, ListItemText } from "@mui/material";
import {
  useMaterialUIController,
  setNotification,
  setLoading,
  setTitle,
  setHeader,
} from "context";

import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";
import { getCapsuleWithID } from "controllers/MenuController";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";

export default function NotificationView(props) {
  const [controller, dispatch] = useMaterialUIController();

  const navigate = useNavigate();
  const [datas, setDatas] = useState();
  const myRef = useRef(null);
  useEffect(() => {
    setLoading(dispatch, false);
    setTitle(dispatch, {
      title: getText("notification", "fa"),
      subtitle: "",
    });
    setHeader(dispatch, "header");
    console.log("myRef.current", myRef.current);
    if (myRef.current !== null) {
      myRef.current.scrollIntoView();
    }
    getData();
  }, []);
  const getData = async () => {
    try {
      let data = await getNotifications(controller);
      console.log("datadatadatadata", data);
      if (data.success) {
        setDatas(data.data);
      } else {
        Swal.fire({
          text: data.message,
          position: "bottom-end",
          background: "#f1b3af",
          showConfirmButton: false,
          timer: 2500,
        });
      }
    } catch (err) {
      console.log(err);
    }
  };
  const clickHandler = async (item) => {
    try {
      let data = await updateNotificationReaded({ id: item._id }, controller);

      if (item.mode === "colleague") {
        let link = JSON.parse(item.link);

        setLoading(dispatch, true);
        let fileRes = await getFileWithID(link.file, controller);
        console.log("datasss", item.mode, fileRes);
        setLoading(dispatch, false);
        if (fileRes.success) {
          if (fileRes.data !== null) {
            let menu = await localStorage.getItem("$menu");
            menu = JSON.parse(menu);
            menu.isMyFile = false;
            menu.limitedFile = link.limited;
            menu.file = link.file;
            menu.nationalCode = fileRes.data.patientNationalCode;
            menu.showResultOfFile = false;
            menu.capsule = fileRes.data.capsule._id;
            menu.capsuleText = fileRes.data.capsule.capsuled.text;
            menu.from = "notification";
            menu.visitedpageslist = [];
            // if (menu.headline === "complaints") {
            //   menu.headlineText = "Clinics";
            // } else if (menu.headline === "diseases") {
            //   menu.headlineText = "Book review";
            // } else if (menu.headline === "scores") {
            //   menu.headlineText = "Scores";
            // }
            await localStorage.setItem("$menu", JSON.stringify(menu));
            if (data.success) {
              setNotification(dispatch, controller.notification - 1);
            }
            navigate("/pageview");
          }
        } else {
        }
        return;
      } else if (item.mode === "forum") {
        if (
          controller.userRole === "assistant" ||
          controller.userRole === "secretary"
        ) {
          return;
        }
        let link = JSON.parse(item.link);

        let capRes = await getCapsuleWithID(link.capsule, controller);

        if (capRes.success) {
          if (capRes.data !== null) {
            let menu = await localStorage.getItem("$menu");
            menu = JSON.parse(menu);

            menu.capsule = capRes.data.id;
            menu.file = "";
            menu.openFrom = "notification";
            menu.capsuleText = capRes.data.text;

            await localStorage.setItem("$menu", JSON.stringify(menu));

            navigate("/chatroom/" + link.group);
          }
        } else {
        }
        return;
      }
      
    } catch (err) {
      console.log(err);
    }
  };
  return (
    <DashboardLayout>
      <DashboardNavbar title={getText("questions", "fa")} />
      <div style={{ width: "100%", height: 1 }}></div>
      <div className={"fa" === "en" ? "listmenu" : "listmenu rtl"}>
        <List>
          {datas &&
            datas.map((item) => (
              <ListItem
                className="list"
                key={item.id}
                button
                onClick={() => {
                  clickHandler(item);
                }}
                style={{ borderBottom: "1px solid #039dfc" }}
              >
                {/* <SaveOutlinedIcon style={{ color: "#039dfc", paddingRight: 5 }} /> */}
                <ListItemText>
                  <div
                    className={
                      item.read === true ? "menutext texdecoration" : "menutext"
                    }
                  >
                    {"fa" === "en" ? item.text : item.textfa}
                  </div>
                </ListItemText>
              </ListItem>
            ))}
        </List>
      </div>
      <Footer />
    </DashboardLayout>
  );
}
